.interchangeLogomark {
  .stop1_0 {
    stop-color: var(--ixf-color-secondary-md);
  }

  .stop1_1 {
    stop-color: var(--ixf-color-primary-md);
  }

  .stop2_0 {
    stop-color: var(--ixf-color-secondary-md);
  }

  .stop2_1 {
    stop-color: #C94BB7;
    stop-color: color(display-p3 0.7882 0.2941 0.7176);
  }

  .stop3_0 {
    stop-color: #FC6469;
    stop-color: color(display-p3 0.9882 0.3922 0.4118);
  }

  .stop3_1 {
    stop-color: #C94BB7;
    stop-color: color(display-p3 0.7882 0.2941 0.7176);
  }
}
